import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { buildFilters, filterData } from '../helpers/filterUtils';
import * as log from '../utils/log';
import useQuery from './useQuery';
const buildFilteredData = (data, query, filterConfig) => {
    if (!data)
        return [];
    if (Object.keys(query).length === 0)
        return data;
    const filters = buildFilters(query, filterConfig);
    return filterData(data, filters);
};
const useFilters = (data, filterConfig, setter) => {
    const query = useQuery();
    const queryStatic = JSON.stringify(query);
    log.debug('Query', queryStatic);
    const [filteredData, setFilteredData] = useState(data);
    const dispatch = useDispatch();
    useEffect(() => {
        const newData = buildFilteredData(data, query, filterConfig);
        setFilteredData(newData);
        if (setter) {
            log.debug('Filter data update -> ', newData);
            dispatch(setter(newData));
        }
    }, [data, queryStatic, dispatch]);
    return filteredData;
};
export default useFilters;
